import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./ContainerUIHelpers";

const ContainerUIContext = createContext();

export function useContainerUIContext() {
  return useContext(ContainerUIContext);
}

export const ContainerUIConsumer = ContainerUIContext.Consumer;

export function ContainerUIProvider({ ContainerUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openEditProductPage: ContainerUIEvents?.openEditProductPage,
    openDeleteProductDialog: ContainerUIEvents?.openDeleteProductDialog,
    openDeleteContainerDialog: ContainerUIEvents?.openDeleteContainerDialog,
    openFetchContainerDialog: ContainerUIEvents?.openFetchContainerDialog,
    openUpdateContainerStatusDialog:
      ContainerUIEvents?.openUpdateContainerStatusDialog,
  };

  return (
    <ContainerUIContext.Provider value={value}>
      {children}
    </ContainerUIContext.Provider>
  );
}
